import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { reportAPI } from '../utils/api';
import { ClipboardList, Search } from 'lucide-react';
import toast from 'react-hot-toast';
import SectionHero from '../components/common/SectionHero';

const ACTION_COLORS = {
  CREATE: 'badge-green',
  UPDATE: 'badge-blue',
  DELETE: 'badge-red',
  ADJUST: 'badge-orange',
  TRANSFER: 'badge-blue',
};

export default function AuditLog() {
  const { t } = useTranslation();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    reportAPI.auditLog()
      .then(r => setLogs(r.data))
      .catch(() => toast.error(t('error')))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line

  const filtered = logs.filter(l =>
    !search ||
    l.user?.toLowerCase().includes(search.toLowerCase()) ||
    l.action?.toLowerCase().includes(search.toLowerCase()) ||
    l.table?.toLowerCase().includes(search.toLowerCase())
  );

  const formatDate = str => {
    if (!str) return '—';
    const d = new Date(str);
    return d.toLocaleString();
  };

  return (
    <div className="space-y-5">
      <SectionHero title={t('audit_log')} subtitle={<>{t('last_500_actions')}</>} />

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
          <Search size={15} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />
          <input className="input" style={{ border:'none', background:'transparent', padding:0, fontSize:13 }} placeholder={t('search') + '...'} value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {loading ? (
          <div className="loading-center"><div className="spinner" /></div>
        ) : filtered.length === 0 ? (
          <div className="empty-state"><ClipboardList size={32} style={{ color:'var(--text-muted)', margin:'0 auto 8px' }} /><p>{t('no_data')}</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr>
                <th>{t('time')}</th>
                <th>{t('user')}</th>
                <th>{t('action')}</th>
                <th>{t('section')}</th>
                <th className="hide-mobile">{t('record_id')}</th>
              </tr></thead>
              <tbody>
                {filtered.map(l => (
                  <tr key={l.id}>
                    <td style={{ color:'var(--text-muted)', fontSize:12, fontFamily:'monospace', whiteSpace:'nowrap' }}>{formatDate(l.created_at)}</td>
                    <td style={{ color:'var(--text-primary)', fontWeight:500 }}>{l.user}</td>
                    <td><span className={`badge ${ACTION_COLORS[l.action] || ''}`}>{t('action_' + l.action, l.action)}</span></td>
                    <td style={{ fontSize:12 }}>{t('table_' + l.table, l.table)}</td>
                    <td className="hide-mobile" style={{ fontFamily:'monospace', fontSize:11, color:'var(--text-muted)' }}>{l.record_id ? l.record_id.slice(0,8) + '…' : '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

